import Account from './Account';
import Animal from './Animal';
import Armchair from './Armchair';
import Basket from './Basket';
import BathTub from './BathTub';
import BigDrill from './BigDrill';
import Brush from './Brush';
import BurgerMenu from './BurgerMenu';
import Close from './Close';
import Drill from './Drill';
import FaucetWater from './FaucetWater';
import Flash from './Flash';
import Hammer from './Hammer';
import Hood from './Hood';
import Lamp from './Lamp';
import List from './List';
import MessageCircle from './MessageCircle';
import Phone from './Phone';
import Promo from './Promo';
import Promos from './Promos';
import Screw from './Screw';
import Search from './Search';
import Spinner from './Spinner';
import Wall from './Wall';
import WateringCan from './WateringCan';

export default {
  Account,
  Animal,
  Armchair,
  Basket,
  BathTub,
  BigDrill,
  Brush,
  BurgerMenu,
  Close,
  Drill,
  FaucetWater,
  Flash,
  Hammer,
  Hood,
  Lamp,
  List,
  MessageCircle,
  Phone,
  Promo,
  Promos,
  Screw,
  Search,
  Spinner,
  Wall,
  WateringCan,
};
